import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { MarketBanner } from "@market/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { UNSAFE_DataRouterContext } from "react-router-dom";
import { withI18n } from "../libs/platform/service-i18n/dist/components.js";
import { hasErrorContext } from "../ContextError.js";
import { CaptureAsyncError } from "./CaptureAsyncError.js";
import { CaptureRouterError } from "./CaptureRouterError.js";
class ErrorBoundaryComponent extends React.Component {
  // needed to get access to "isDataRoute"
  static contextType = UNSAFE_DataRouterContext;
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    this.props.onError?.(error, errorInfo);
    const errorContext = hasErrorContext(error) ? error.context : {};
    this.props.errorTrackingClient.captureException(error, {
      captureContext: {
        extra: {
          ...errorInfo,
          ...errorContext
        }
      }
    });
  }
  render() {
    const isWithinDataRoute = this.context;
    const {
      errorTrackingClient,
      errorMessage,
      fallback,
      children
    } = this.props;
    if (this.state.hasError || !children) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        isWithinDataRoute && /* @__PURE__ */ jsx(CaptureRouterError, { errorTrackingClient }),
        /* @__PURE__ */ jsx(CaptureAsyncError, { errorTrackingClient }),
        fallback || /* @__PURE__ */ jsx(ErrorBanner, { errorMessage })
      ] });
    }
    return children;
  }
}
const ErrorBanner = withI18n(({ errorMessage }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(MarketBanner, { variant: "critical", children: errorMessage || t("errorBoundary.default") });
});
const ErrorBoundary = ErrorBoundaryComponent;
export {
  ErrorBoundary
};
//# sourceMappingURL=index.js.map
